import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Input, OnDestroy, OnInit} from '@angular/core';
import {Subject, Subscription, takeUntil} from 'rxjs';
import { AllService } from '../../../services/all.service';
import { IMessengerConnector } from '../../../types/all.type';
import {filter} from 'rxjs/operators';
import {DcService} from '../../../services/dc.service';

@Component({
  selector: 'app-battery-indicator',
  templateUrl: './battery-indicator.component.html',
  styleUrls: ['./battery-indicator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BatteryIndicatorComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject();
  @Input() Service: IMessengerConnector;
  @Input() showPercent = false;
  @Input() verticalMode = true;
  public isActual = true;
  subscriptions: Subscription[] = [];
  constructor(
    private dcService: DcService,
    public allService: AllService,
    private cd: ChangeDetectorRef
  ) {}
  ngOnInit(): void {
    this.subscriptions.push(
      this.dcService.detectChanges$.pipe(takeUntil(this.destroy$), filter(v => v === 'battery-indicator')).subscribe((component) => {
        this.isActual = true;
        this.cd.detectChanges();
      })
    );
    this.checkActual();
    setInterval(() => {
      this.checkActual();
    }, 60000);
  }
  checkActual() {
    if (this.Service.arProfile?.batteryLastTime < Date.now() - 60 * 30 * 1000) {
      this.isActual = false;
      this.cd.detectChanges();
    }
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
